import React, { useContext, useEffect } from "react";
import Cars from "../elements/cars";
import { useDispatch, useSelector } from "react-redux";
import { fetchCars } from "../redux/actions";
import { Loader } from "../elements/loader";
import { Carcontext } from "../context/carcontext";
import $ from 'jquery'

const CarsList = () => {

    const dispatch = useDispatch()
    const cars = useSelector((state) => {
        return state.cars.carsInfo
    })
    const loading = useSelector(state => state.app.loading)
    const { theme } = useContext(Carcontext)

    useEffect(() => {
        if (cars.length > 0) {
            return
        } else {
            dispatch(fetchCars())
        }
    }, [])

    if (loading) {
        return <Loader theme={theme} />
    }



    return (
        <div className="pagination-wrapper">
            <div className="cards">
                {
                    cars.map((car, index) => <Cars car={car} key={index} />)
                }
            </div>
        </div>
    )

};


export default CarsList